import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { motion } from 'framer-motion';

type SubscribeCardProps = {
  scrollToSection: (_id: string) => void;
};

const features = [
  'Assinaturas digitais incluídas',
  'Dashboard analítico completo',
  'Suporte prioritário 24/7',
  'Integração com outros sistemas',
];

const SubscribeCard = ({ scrollToSection }: SubscribeCardProps) => {
  return (
    <motion.div
      className="bg-white rounded-2xl shadow-lg border border-gray-100 flex flex-col items-center text-center overflow-hidden"
      initial={{ opacity: 0, x: -32 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.65, ease: 'easeOut' }}
      viewport={{ once: true }}
    >
      {/* Banner topo */}
      <div className="w-full bg-[--secondary-color] py-2.5 px-4">
        <p className="text-white text-xs font-bold uppercase tracking-widest">
          Oferta especial — primeiros clientes
        </p>
      </div>

      <div className="p-10 flex flex-col items-center w-full">
        <p className="text-[--primary-color] text-xs font-bold uppercase tracking-widest mb-4">
          Plano Profissional
        </p>

        <span className="text-gray-400 text-sm font-medium line-through mb-1">
          R$249,99/mês
        </span>

        <div className="flex items-baseline gap-1 mb-2">
          <span className="text-[--primary-color] text-7xl font-extrabold leading-none">R$99</span>
          <span className="text-gray-400 text-lg font-medium">/mês</span>
        </div>

        <p className="text-[--terciary-color] text-sm font-semibold mb-8">
          Tudo que você precisa para começar
        </p>

        <ul className="w-full space-y-3 mb-10 text-left">
          {features.map((f) => (
            <li key={f} className="flex items-center gap-3 text-[--primary-color] text-sm">
              <CheckCircleIcon sx={{ color: '#CB88F9', fontSize: 20, flexShrink: 0 }} />
              {f}
            </li>
          ))}
        </ul>

        <button
          className="w-full bg-[--primary-color] text-white font-bold py-4 rounded-xl hover:bg-[--primary-color-hover] active:scale-[0.98] transition-all duration-200 shadow-md"
          onClick={() => scrollToSection('contact')}
        >
          Começar Agora
        </button>
      </div>
    </motion.div>
  );
};

export default SubscribeCard;